let compareLink
let compareListLinkEl
let compareListLink = {
  starEl: '',
  textEl: '',
}
let compareToggleEls
let compareDeleteContainerEls

export function initCompare() {
  if (!window['COMPARE_LINK']) return false

  compareLink = window['COMPARE_LINK']

  compareListLinkEl = document.querySelector('.js-compare-list-link')
  compareToggleEls = document.querySelectorAll('.js-compare-toggle')
  compareDeleteContainerEls = document.querySelectorAll('.js-compare-delete-container')

  if (compareListLinkEl) initCompareListLink()
  if (compareToggleEls.length) initCompareToggle()
  if (compareDeleteContainerEls.length) initCompareDelete()
}

function initCompareListLink() {
  compareListLink.starEl = document.querySelector('.js-compare-star')
  compareListLink.textEl = document.querySelector('.js-compare-text')

  compareListLinkEl.addEventListener('click', () => {
    if (compareListLinkEl.classList.contains('active')) {
      location.assign(compareLink)
    } else {
      $.fancybox.open(document.querySelector('.js-compare-popup'))
    }
  })
}

function initCompareToggle() {
  compareToggleEls.forEach(compareToggleEl =>
    compareToggleEl.addEventListener('click', () =>
      toggleCompare(compareToggleEl.dataset.productId, compareToggleEl)
        .then(success => {
          if (success) {
            compareToggleEl.classList.toggle('active')
          }
        })
    )
  )
}

function initCompareDelete() {
  compareDeleteContainerEls.forEach(compareDeleteContainerEl => {
    const compareDeleteEl = compareDeleteContainerEl.querySelector('.js-compare-delete')

    compareDeleteEl.addEventListener('click', () =>
      toggleCompare(compareDeleteEl.dataset.productId, compareDeleteEl)
        .then(success => {
          if (success) {
            compareDeleteContainerEl.classList.add('deleting')
            setTimeout(() => compareDeleteContainerEl.remove(), 400)
          }
        })
    )
  })
}

function toggleCompare(productId) {
  return fetch(compareLink + '/toggle&id=' + productId)
    .then(response => {
      if (response.ok) return response.json()
    })
    .then(json => {
      checkCompareListLink(json.total)
      return json.success
    })
}

function checkCompareListLink(total) {
  if (!compareListLinkEl) return

  // yea, its fun =)
  if (Object.keys(total).length >= 1) {
    compareListLinkEl.classList.add('active')
    compareListLink.starEl.classList.add('active')
    compareListLink.textEl.classList.add('active')
    compareListLink.textEl.textContent = 'Перейти к сравнению'
  } else {
    compareListLinkEl.classList.remove('active')
    compareListLink.starEl.classList.remove('active')
    compareListLink.textEl.classList.remove('active')
    compareListLink.textEl.textContent = 'Список сравнения'
  }
}
